<template>
  <section class="main-section">
    <div class="main-section-container container">
      <div class="row">
        <div class="col">
          <div class="text-heading" ref="mainText">
            C Новым годом!
          </div>
        </div>
        <div class="gift-box-container" ref="giftContainer">
          <img
            :src="require('@/assets/image/main-section/gift.png')"
            ref="giftbox"
            alt="Подарок"
            class="giftbox-img giftbox">
          <img
            :src="require('@/assets/image/main-section/candy.png')"
            ref="candy"
            alt="Карамельная палочка"
            class="giftbox-img candy">
          <img
            :src="require('@/assets/image/main-section/candy_ball_1.png')"
            ref="candyBall1"
            alt="Конфета"
            class="giftbox-img candy-ball-1">
          <img
            :src="require('@/assets/image/main-section/candy_ball_2.png')"
            ref="candyBall2"
            alt="Конфета"
            class="giftbox-img candy-ball-2">
          <img
            :src="require('@/assets/image/main-section/ball.png')"
            ref="ball"
            alt="Новогодняя игрушка"
            class="giftbox-img ball">
          <img
            :src="require('@/assets/image/main-section/star.png')"
            ref="star"
            alt="Звезда"
            class="giftbox-img star">
          <img
            :src="require('@/assets/image/main-section/spheres_1.png')"
            ref="spheres1"
            alt="Новогоднее украшение"
            class="giftbox-img spheres-1">
          <img
            :src="require('@/assets/image/main-section/spheres_2.png')"
            ref="spheres2"
            alt="Новогоднее украшение"
            class="giftbox-img spheres-2">
          <img
            :src="require('@/assets/image/main-section/apple.png')"
            ref="apple"
            alt="Яблоко"
            class="giftbox-img apple">
          <img
            :src="require('@/assets/image/main-section/gingercook.png')"
            ref="gingercook"
            alt="Имбирный пряник"
            class="giftbox-img gingercook">
          <img
            :src="require('@/assets/image/main-section/snow.png')"
            ref="snow"
            alt="Снежинка"
            class="giftbox-img snow">
          <img
            :src="require('@/assets/image/main-section/tree.png')"
            ref="tree"
            alt="Ветка"
            class="giftbox-img tree">
        </div>
        <div class="scroll-down-container" ref="scrolldownContainer">
          <img
            :src="require('@/assets/image/main-section/scrolldown.png')"
            ref="scrolldown"
            alt="Arrow Down"
            class="scrolldown">
          листайте вниз
        </div>
      </div>
      <div class="stripes-bg" ref="stripes">
      </div>
    </div>
  </section>
</template>
<script>
import { gsap, TweenMax } from 'gsap';

export default {
  name: 'v-main-section',
  props: {

  },
  mounted() {
    TweenMax.to(
      this.$refs.giftbox, 2, {
        y: '-1px',
        x: '2px',
        rotate: 2,
        repeatDelay: 0,
        repeat: -1,
        yoyo: true,
        ease: 'linear',
      },
    );
    TweenMax.to(
      this.$refs.scrolldown, 2, {
        y: '-25px',
        repeatDelay: 0,
        repeat: -1,
        yoyo: true,
        ease: 'power2.inOut',
      },
    );
    TweenMax.to(
      this.$refs.candy, 2, {
        rotate: '-6deg',
        repeatDelay: 0,
        repeat: -1,
        yoyo: true,
        ease: 'power2.inOut',
      },
    );
    TweenMax.to(
      this.$refs.candyBall1, 2, {
        y: '-3',
        repeatDelay: 0,
        repeat: -1,
        yoyo: true,
        ease: 'power2.inOut',
      },
    );
    TweenMax.to(
      this.$refs.candyBall2, 4, {
        y: '-2',
        repeatDelay: 0,
        repeat: -1,
        yoyo: true,
        ease: 'power2.inOut',
      },
    );
    TweenMax.to(
      this.$refs.ball, 2, {
        y: '-10',
        repeatDelay: 0,
        repeat: -1,
        yoyo: true,
        ease: 'power2.inOut',
      },
    );
    TweenMax.to(
      this.$refs.star, 2, {
        y: '10',
        repeatDelay: 0,
        repeat: -1,
        yoyo: true,
        ease: 'power2.inOut',
      },
    );
    TweenMax.to(
      this.$refs.gingercook, 2, {
        y: '2',
        rotate: '3deg',
        repeatDelay: 0,
        repeat: -1,
        yoyo: true,
        ease: 'power2.inOut',
      },
    );
    TweenMax.to(
      this.$refs.spheres1, 2, {
        y: '7',
        repeatDelay: 0,
        repeat: -1,
        yoyo: true,
        ease: 'power2.inOut',
      },
    );
    TweenMax.to(
      this.$refs.spheres2, 2, {
        y: '-10',
        repeatDelay: 0,
        repeat: -1,
        yoyo: true,
        ease: 'power2.inOut',
      },
    );
    TweenMax.to(
      this.$refs.apple, 2, {
        rotate: '-10deg',
        repeatDelay: 0,
        repeat: -1,
        yoyo: true,
        ease: 'power2.inOut',
      },
    );
    TweenMax.to(
      this.$refs.snow, 2, {
        y: '-5',
        rotate: '4deg',
        repeatDelay: 0,
        repeat: -1,
        yoyo: true,
        ease: 'power2.inOut',
      },
    );
    TweenMax.to(
      this.$refs.tree, 2, {
        y: '7',
        repeatDelay: 0,
        repeat: -1,
        yoyo: true,
        ease: 'power2.inOut',
      },
    );
    const stripesAnimation = gsap.timeline({ repeat: 0 });
    stripesAnimation.to(this.$refs.stripes, 0, {
      backgroundPositionX: '100%',
      backgroundPositionY: '-100%',
    })
      .to(this.$refs.stripes, 2, {
        backgroundPositionX: '38%',
        backgroundPositionY: '-5%',
      })
      .from(this.$refs.mainText, 2, {
        opacity: 0,
        y: '20px',
      }, '-=0.5')
      .from(this.$refs.giftContainer, 2, {
        opacity: 0,
        scale: 0.95,
      }, '-=2')
      .from(this.$refs.scrolldownContainer, 1, {
        opacity: 0,
      }, '-=1.7');
  },
};

</script>
<style lang="scss">
.main-section{
  padding-top: 53px;
  //background-color: #E30611;
  background-image: url('../assets/image/main-section/noise.png');
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: bottom center;
  position: relative;
  height: 100%;
  z-index: 10;

  .container{
    position: relative;
    height: calc(var(--vh) * 100 - 54px);
    display: flex;
    flex-direction: column;
  }

  .text-heading{
    font-weight: 900;
    font-size: 32px;
    color: #ffffff;
    line-height: 1.1;
    text-transform: uppercase;
    padding: 30px 0;
    position: relative;
    z-index: 10;
    text-align: center;

    @media(max-width: 360px){
      font-size: 28px;
    }
  }

  .row, .col{
    position: relative;
  }
}

.stripes-bg{
  position: absolute;
  width: 100%;
  height: calc(var(--vh) * 200);
  //overflow: hidden;
  top: 0;
  left: 0;
  z-index: 2;
  background-image: url('../assets/image/main-section/stripes.svg');
  background-position: -100% -100%;
  background-repeat: no-repeat;
}

.gift-box-container{
  width: 100%;
  height: 400px;
  overflow: hidden;
  position: relative;
  z-index: 5;

  @media(max-width: 360px){
    height: calc(var(--vh) * 53);
  }
}

.giftbox-img{
  position: absolute;
}

.giftbox{
  max-width: 100%;
  left: -15px;
  z-index: 6;
}

.scroll-down-container{
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 10;
  text-align: center;
  color: #ffffff;

  img{
    width: 44px;
    margin: 0 auto 10px;
  }
}

.candy{
  left: -12%;
  max-width: 110px;
  top: 15%;
}
.tree{
  z-index: 3;
  right: 10%;
  top: 0;
  max-width: 105px;
}
.apple{
  max-width: 130px;
  right: 0%;
  z-index: 4;
  top: 15%;
}
.star{
  max-width: 200px;
  right: 0;
  top: 0;
  z-index: 3;
}
.spheres-1{
  right: 0;
  top: 5%;
  z-index: 3;
  max-width: 130px;
}
.spheres-2{
  left: 7%;
  top: 15%;
  z-index: 3;
  max-width: 49px;
}
.candy-ball-1{
  left: 0%;
  top: 40%;
  z-index: 6;
  max-width: 105px;
}
.candy-ball-2{
  left: 1%;
  top: 55%;
  z-index: 6;
  max-width: 95px;
}
.ball{
  max-width: 85px;
  top: 0px;
  left: 20%;
}
.gingercook{
  right: 10%;
  top: 45%;
  z-index: 6;
  max-width: 132px;
}
.snow{
  left: 18%;
  top: 57%;
  z-index: 6;
  max-width: 170px;
}

@media(min-width: 500px){
  .gift-box-container{
    height: 550px;
  }
  .candy{
    left: -3%;
  }
}
@media(max-width: 400px) and (max-height: 610px){
  .gift-box-container{
    height: 350px;
  }
}
@media(max-width: 400px) and (min-height: 750px){
  .gift-box-container{
    height: 400px;
  }
}
@media(max-width: 360px) and (max-height: 550px){
  .gift-box-container{
    height: 270px;

    img{
      transform: scale(0.9);
    }
  }
  .snow{
    top: 57%;
    max-width: 140px;
  }
  .gingercook{
    max-width: 110px;
    top: 50%;
  }
  .main-section .text-heading {
    padding: 20px 0 5px;
  }
}
</style>
